import { Stack } from '@mantine/core'
import { LoanParams } from 'app/models/loan-params'
import { formatDateToShow, formatNumberToCurrency, numberOfDaysBetweenTwoDates, stringToDate } from 'app/utils/util-functions'
import MainTable from 'app/views/components/Table/MainTable'
import { getColumnDefs } from './table-columnDefs-prepayment-summary'

type Props = {
  interestDue: number
  currency: string
  loan: LoanParams
  paymentDate: Date
  paymentAmount: number
}

export default function PrepaymentSummary({ interestDue, currency, loan, paymentDate, paymentAmount }: Props) {
  return (
    <Stack spacing={0}>
      <div
        style={{
          backgroundColor: '#A4CAFE',
          width: '100%',
          padding: '10px',
          color: 'black',
          fontSize: '14px',
          fontWeight: 'bold',
        }}
      >
        Prepayment Summary
      </div>
      <MainTable
        tableName='Loan History'
        csvExportEnabled={true}
        columnDefs={getColumnDefs()}
        data={[{
          'Start Date': formatDateToShow(loan?.startDate ? stringToDate(loan.startDate) : undefined),
          'End Date': formatDateToShow(paymentDate),
          'Payment Amount': formatNumberToCurrency(Number(paymentAmount), currency),
          'All-In Rate': loan.allInRate + "%",
          'Days': Math.round(numberOfDaysBetweenTwoDates(new Date(loan.startDate), new Date(paymentDate))),
          'Interest Amount': formatNumberToCurrency(interestDue, currency)
        }]}
        enableTopToolbar={false}
        headerBackgroundColor='#F0EEEE'
        setRow={() => {
        }}
        withPagination={false}
        minHeight={'100px'}
      />
    </Stack>

  )
}
